import { Flex, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Content, EditButtonLink } from '@/core/components';

import { Department } from './model/DepartmentTypes';

interface DepartmentViewProps {
  department: Department;
}

export function DepartmentView(props: DepartmentViewProps) {
  const { t } = useTranslation();

  const { department } = props;
  const { name } = department;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{name}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              {/*<DepartmentDeleteButton departmentId={department.id} /> TODO ENABLE AFTER SECURITY CHECK*/}
            </Group>
          </Flex>
        </Stack>
      </Content>

      <Content type="full">
        <Text fw="500">{t('departments.form.fields.faculty')}</Text>
        <Group>{department.faculty.name}</Group>
      </Content>

      {department.headOfDepartment && (
        <Content type="full">
          <Text fw="500">{t('departments.form.fields.headOfDepartment')}</Text>
          <Group>{department.headOfDepartment.email}</Group>
          <Group>
            {department.headOfDepartment.firstName} {department.headOfDepartment.lastName}
          </Group>
        </Content>
      )}
    </Stack>
  );
}
